import React from "react";
import { Handle } from 'react-flow-renderer';
import { handlesColors } from "./";

export const HandleInput = ({isConnectable = true, onConnect}) => {
  return (
    <Handle
    type="target"
    position="left"
    isConnectable={isConnectable}
    style={{  
      borderRadius: "5px 0px 0px 5px", 
      height: "100%", 
      border: "0px solid #7371b5", 
      width: "10px",
      left: "-10px",
      transform: "translateY(0%)", 
      top: "0px",
      opacity: 0.8,
      backgroundColor: handlesColors.B,
    }}
    onConnect={onConnect}
  />
  );
}
